import { useEffect, useRef } from "react";

// Pilha de modais abertos: só o do TOPO responde ao ESC. Sem isso, apertar ESC
// com o "Registrar ajuste" aberto por cima do card fecharia os dois de uma vez.
const pilha: Array<() => void> = [];

/**
 * Fecha um modal/drawer no ESC (pedido da Thainá).
 *
 * `temConteudo` protege o que a pessoa digitou: se voltar true, o ESC pede
 * confirmação antes de descartar — o problema que ela relatou era justamente
 * perder texto sem querer, então o atalho não pode virar outra forma de perder.
 */
export function useFecharComEsc(onFechar: () => void, temConteudo?: () => boolean) {
  const ref = useRef({ onFechar, temConteudo });
  ref.current = { onFechar, temConteudo };

  useEffect(() => {
    const fechar = () => {
      const { onFechar, temConteudo } = ref.current;
      if (temConteudo?.() && !window.confirm("Descartar o que você escreveu?")) return;
      onFechar();
    };
    pilha.push(fechar);

    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      // ESC "local" (fechar dropdown, cancelar edição inline) tem prioridade.
      if (pilha[pilha.length - 1] !== fechar) return;
      e.preventDefault();
      fechar();
    };
    window.addEventListener("keydown", aoTeclar);

    return () => {
      const i = pilha.indexOf(fechar);
      if (i >= 0) pilha.splice(i, 1);
      window.removeEventListener("keydown", aoTeclar);
    };
  }, []);
}
